export default __webpack_public_path__ + "static/media/abacatepay.50e1cfa2.png";